import NotificationList from 'libs/components/notifications/list';
import NotificationListItem from 'libs/components/notifications/list-item';

export default function(params) {
  var self = this;

  self.$parentNode = $(params.parentNode);
  self.notificationLists = ko.observableArray();
  self.lastPage = ko.observable(false);
  self.groups = [];
  self.nextPage = 1;

  self.init = function() {
    self.getData(1, self.groupByDate, self.requestFail);
    // self.groupByDate(params);
    self.watchScroll(window);
  };

  self.getData = function(page, success, fail) {
    let request = new Kadenze.AjaxRequest({
      type: 'GET',
      dataAsJSON: false,
      url: Kadenze.Routes.notifications_path(),
      data: { page: page },
      cache: false, // Addressing KADWEB-2958,
      loadingIndicator: {
        container: self.$parentNode,
        positionTop: 'fixed'
      }
    });

    request.done(function(response) {
      success(response);
    });

    request.fail(fail);
  };

  self.requestFail = function(response) {
    console.warn('JSON request for notifications failed. Response:');
    console.log(response);
  };

  // Assumes response.notifications exists
  self.groupByDate = function(response) {
    self.groups = [];

    if(response.notifications.length < 1) {
      new Kadenze.Notice({ title: Kadenze.I18n.t('notifications.loading_complete'), message: Kadenze.I18n.t('notifications.all_notifications_have_loaded') });

      return self.lastPage(true);
    }

    _.each(response.notifications, function(item){
      var date = moment(item.created_at),
        title = self.determineTitle(date),
        index = _.findIndex(self.groups, { title: title }),
        existingIndex = self.notificationListExists({ title: title });

      if(existingIndex) {
        self.addToExistingList(existingIndex, item);
      } else if(index > -1) {
        self.groups[index].items.push(item);
      } else {
        self.groups.push({ title: title, items: [item] });
      }
    });

    self.buildLists(self.groups);
  };

  self.notificationListExists = function(notification) {
    var curLists = ko.toJS(self.notificationLists()),
      index = _.findIndex(curLists, { title: notification.title });

    return index > -1 ? index : false;
  };

  self.addToExistingList = function(listIndex, notification) {
    var list = self.notificationLists()[listIndex];

    list.items.push(new NotificationListItem(notification));
  };

  self.determineTitle = function(itemDate) {
    var yesterday = moment().subtract(1, 'day'),
      isToday = itemDate.isSame(moment(), 'day'),
      isYesterday = itemDate.isBefore(moment()) && itemDate.isAfter(yesterday);

    if(isToday) {
      return 'Today';
    } else if(isYesterday) {
      return 'Yesterday';
    } else {
      return itemDate.format('MMM D');
    }
  };

  self.buildLists = function(items) {
    _.each(items, function(item) {
      self.notificationLists.push(new NotificationList(item));
    });
  };

  // Infinite scroll logic
  self.watchScroll = function(elem) {
    var $el = $(elem),
      debounced = _.debounce(self.scrollHandler, 300);

    $el.on('scroll', debounced);
  };

  self.scrollHandler = function(event) {
    let $el = $(event.currentTarget);
    let isAtBottom = ($el.scrollTop() + $el.height()) == $(document).height();

    if(isAtBottom && !self.lastPage()) {
      self.nextPage += 1;
      self.getData(self.nextPage, self.groupByDate, self.requestFail);
    }
  };

  self.init();

  return self;
}
